import { DEMO_EMPLOYEE_SOURCE, demoEmployeeIdsStorageKey } from './constants';
import { deleteEmployee, getEmployee } from '../api/companyRecords';

async function deleteTrackedEmployees(companyId, ids) {
  if (!companyId || !ids.length) return 0;

  let deleted = 0;
  for (const id of ids) {
    try {
      const employee = await getEmployee({ companyId, id });
      if (!employee || employee.source !== DEMO_EMPLOYEE_SOURCE) continue;
      await deleteEmployee({ companyId, id });
      deleted += 1;
    } catch (error) {
      if (error.status === 404) continue;
      throw error;
    }
  }
  return deleted;
}

export async function clearDemoEmployees(companyId, { isSpecialAdmin = false } = {}) {
  if (!isSpecialAdmin) {
    throw new Error('Demo employees are available to special admins only.');
  }

  const storageKey = demoEmployeeIdsStorageKey(companyId);
  const storedRaw = window.localStorage.getItem(storageKey);
  const stored = storedRaw ? JSON.parse(storedRaw) : null;
  const storedIds = stored?.employeeIds || [];

  const deleted = await deleteTrackedEmployees(companyId, storedIds);
  window.localStorage.removeItem(storageKey);

  if (deleted === 0 && storedIds.length === 0) {
    return { deleted: 0, message: 'No tracked demo employees found for this browser session.' };
  }

  return {
    deleted,
    message: deleted > 0
      ? `Removed ${deleted} demo employee${deleted === 1 ? '' : 's'}.`
      : 'No demo employees were removed (they may have been deleted already).',
  };
}
